import { DateTimePicker } from "@syncfusion/ej2-angular-calendars";

export class CerDateTimeEdit extends DateTimePicker
{

}
